let data = {
	"businessTree": [{
		"checkState": 0,
		"checked": null,
		"children": [{
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "5",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "农业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "6",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "林业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "7",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "畜牧业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "8",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "渔业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "4",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "农、林、牧、渔业",
			"total": 0,
			"type": null,
			"url": null
		}],
		"cls": null,
		"data": null,
		"expanded": false,
		"iconCls": null,
		"id": "1",
		"leaf": false,
		"qtip": null,
		"remarks": null,
		"state": null,
		"text": "第一产业",
		"total": 0,
		"type": null,
		"url": null
	}, {
		"checkState": 0,
		"checked": null,
		"children": [{
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "10",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "煤炭开采和洗选业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "11",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "石油和天然气开采业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "12",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "黑色金属矿采选业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "13",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "有色金属矿采选业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "14",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "非金属矿采选业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "15",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "其它采矿业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "9",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "采矿业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "17",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "农副食品加工业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "18",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "食品制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "19",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "酒、饮料和精制茶制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "20",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "烟草制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "21",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "纺织业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "22",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "纺织服装、服饰业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "23",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "皮革、毛皮、羽毛及其制品和制鞋业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "24",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "木材加工和木、竹、藤、棕、草制品业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "25",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "家具制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "26",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "造纸和纸制品业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "27",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "印刷和记录媒介复制业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "28",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "文教、工美、体育和娱乐用品制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "29",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "化学原料和化学制品制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "30",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "医学制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "31",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "化学纤维制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "32",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "橡胶和塑料制品业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "33",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "非金属矿物制品业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "34",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "黑色金属冶炼和压延加工业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "35",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "有色金属冶炼和压延加工业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "36",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "金属制品业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "37",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "通用设备制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "38",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "专用设备制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "39",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "汽车制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "40",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "铁路、船舶、航空航天和其他运输设备制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "41",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "电气机械和器材制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "42",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "计算机、通信和其他电子设备制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "43",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "仪器仪表制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "44",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "其他制造业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "45",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "废弃资源综合利用业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "16",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "制造业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "47",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "电力、热力生产和供应业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "48",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "燃气生产和供应业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "49",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "水生产和供应业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "46",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "电力、热力、燃气及水生产和供应业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "51",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "房屋建筑业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "52",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "土木工程建筑业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "53",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "建筑安装业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "54",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "建筑装饰和其他建筑业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "50",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "建筑业",
			"total": 0,
			"type": null,
			"url": null
		}],
		"cls": null,
		"data": null,
		"expanded": false,
		"iconCls": null,
		"id": "2",
		"leaf": false,
		"qtip": null,
		"remarks": null,
		"state": null,
		"text": "第二产业",
		"total": 0,
		"type": null,
		"url": null
	}, {
		"checkState": 0,
		"checked": null,
		"children": [{
			"checkState": 0,
			"checked": null,
			"children": null,
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "55",
			"leaf": true,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "农、林、牧、渔服务业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": null,
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "56",
			"leaf": true,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "开采辅助活动",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": null,
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "57",
			"leaf": true,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "金属制品、机械和设备修理业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "59",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "批发业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "60",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "零售业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "58",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "批发和零售业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "62",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "铁路运输业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "63",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "道路运输业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "64",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "水上运输业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "65",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "航空运输业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "66",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "管道运输业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "67",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "装卸搬运和运输代理业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "68",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "仓储业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "69",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "邮政业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "61",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "交通运输、仓储和邮政业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "71",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "住宿业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "72",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "餐饮业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "70",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "住宿和餐饮业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "74",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "电信、广播电视和卫星传输服务",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "75",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "互联网和相关服务",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "76",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "软件和信息技术服务业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "73",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "信息传输、软件和信息技术服务业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "78",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "货币金融服务",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "79",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "资本市场服务",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "80",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "保险业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "81",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "其他金融业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "77",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "金融业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "83",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "房地产业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "82",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "房地产业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "85",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "租赁业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "86",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "商务服务业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "84",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "租赁和商务服务业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "88",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "研究和试验发展",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "89",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "专业技术服务业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "90",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "科技推广和应用服务业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "87",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "科学研究和技术服务业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "92",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "水利管理业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "93",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "生态保护和环境治理业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "94",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "公共设施管理业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "91",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "水利、环境和公共设施管理业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "96",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "居民服务业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "97",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "机动车、电子产品和日用产品修理业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "98",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "其他服务业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "95",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "居民服务、修理和其他服务业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "100",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "教育",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "99",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "教育",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "102",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "卫生",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "103",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "社会工作",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "101",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "卫生和社会工作",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "105",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "新闻和出版业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "106",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "广播、电视、电影和影视录音制作业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "107",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "文化艺术业",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "108",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "体育",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "109",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "娱乐业",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "104",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "文化、体育和娱乐业",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "111",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "中国共产党机关",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "112",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "国家机构",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "113",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "人民政协、民主党派",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "114",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "社会保障",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "115",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "群众团体、社会团体和其他成员组织",
				"total": 0,
				"type": null,
				"url": null
			}, {
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "116",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "基层群众自治组织",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "110",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "公共管理、社会保障和社会组织",
			"total": 0,
			"type": null,
			"url": null
		}, {
			"checkState": 0,
			"checked": null,
			"children": [{
				"checkState": 0,
				"checked": null,
				"children": null,
				"cls": null,
				"data": null,
				"expanded": false,
				"iconCls": null,
				"id": "118",
				"leaf": true,
				"qtip": null,
				"remarks": null,
				"state": null,
				"text": "国际组织",
				"total": 0,
				"type": null,
				"url": null
			}],
			"cls": null,
			"data": null,
			"expanded": false,
			"iconCls": null,
			"id": "117",
			"leaf": false,
			"qtip": null,
			"remarks": null,
			"state": null,
			"text": "国际组织",
			"total": 0,
			"type": null,
			"url": null
		}],
		"cls": null,
		"data": null,
		"expanded": false,
		"iconCls": null,
		"id": "3",
		"leaf": false,
		"qtip": null,
		"remarks": null,
		"state": null,
		"text": "第三产业(服务业)",
		"total": 0,
		"type": null,
		"url": null
	}],
	"cityList": null,
	"citytree": null,
	"dataClassItemList": null,
	"energyDataitemList": null,
	"energyTypeList": null,
	"entList": null,
	"message": null,
	"page": null,
	"pointList": null,
	"success": true
}
export default data.businessTree


// WEBPACK FOOTER //
// ./src/assets/data/BusinessTree.js